// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ArrowRightThick from '../_raw/ui/icon_arrow_right_thick.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ArrowRightThick);
